import { render, staticRenderFns } from "./CoreValueCard.vue?vue&type=template&id=c3f912c4&scoped=true"
import script from "./CoreValueCard.vue?vue&type=script&lang=js"
export * from "./CoreValueCard.vue?vue&type=script&lang=js"
import style0 from "./CoreValueCard.vue?vue&type=style&index=0&id=c3f912c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f912c4",
  null
  
)

export default component.exports